import {TransportEnum} from "../enums/TransferTransportEnum";

export const arrivalFromLabelChoices = [
    { id: TransportEnum.AIRPLANE, name: "transfers.fields.arrivalLocationFromAirplane" },
    { id: TransportEnum.TRAIN, name: "transfers.fields.arrivalLocationFromTrain" },
    { id: TransportEnum.BUS, name: "transfers.fields.arrivalLocationFromBus" },
    { id: TransportEnum.OTHER, name: "transfers.fields.arrivalLocationFrom" },
];

export const departureToLabelChoices = [
    { id: TransportEnum.AIRPLANE, name: "transfers.fields.departureLocationToAirplane" },
    { id: TransportEnum.TRAIN, name: "transfers.fields.departureLocationToTrain" },
    { id: TransportEnum.BUS, name: "transfers.fields.departureLocationToBus" },
    { id: TransportEnum.OTHER, name: "transfers.fields.departureLocationTo" },
];

export const transportReferenceLabelChoices = [
    { id: TransportEnum.AIRPLANE, name: "transfers.fields.airline" },
    { id: TransportEnum.TRAIN, name: "transfers.fields.trainCompany" },
    { id: TransportEnum.BUS, name: "transfers.fields.busCompany" },
    { id: TransportEnum.OTHER, name: "transfers.fields.transportReference" },
];

export const transportReferenceNumberLabelChoices = [
    { id: TransportEnum.AIRPLANE, name: "transfers.fields.flightNumber" },
    { id: TransportEnum.TRAIN, name: "transfers.fields.trainNumber" },
    { id: TransportEnum.BUS, name: "transfers.fields.busNumber" },
    { id: TransportEnum.OTHER, name: "transfers.fields.transportReferenceNumber" },
];

export const arrivalDateLabelChoices = [
    { id: TransportEnum.AIRPLANE, name: "transfers.fields.flightArrivalDate" },
    { id: TransportEnum.TRAIN, name: "transfers.fields.trainArrivalDate" },
    { id: TransportEnum.BUS, name: "transfers.fields.busArrivalDate" },
    { id: TransportEnum.OTHER, name: "transfers.fields.arrivalTransportDate" },
];

export const departureDateLabelChoices = [
    { id: TransportEnum.AIRPLANE, name: "transfers.fields.flightDepartureDate" },
    { id: TransportEnum.TRAIN, name: "transfers.fields.trainDepartureDate" },
    { id: TransportEnum.BUS, name: "transfers.fields.busDepartureDate" },
    { id: TransportEnum.OTHER, name: "transfers.fields.departureTransportDate" },
];

export const arrivalTimeLabelChoices = [
    { id: TransportEnum.AIRPLANE, name: "transfers.fields.flightArrivalTime" },
    { id: TransportEnum.TRAIN, name: "transfers.fields.trainArrivalTime" },
    { id: TransportEnum.BUS, name: "transfers.fields.busArrivalTime" },
    { id: TransportEnum.OTHER, name: "transfers.fields.arrivalTransportTime" },
];

export const departureTimeLabelChoices = [
    { id: TransportEnum.AIRPLANE, name: "transfers.fields.flightDepartureTime" },
    { id: TransportEnum.TRAIN, name: "transfers.fields.trainDepartureTime" },
    { id: TransportEnum.BUS, name: "transfers.fields.busDepartureTime" },
    { id: TransportEnum.OTHER, name: "transfers.fields.departureTransportTime" },
];

